/**
 * Download Management Tabs Component
 * Handles tab navigation and download count updates for file collections
 */
;(function () {
	'use strict'

	/**
	 * Initialize tabs functionality when DOM is ready
	 */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTabs)
	} else {
		initTabs()
	}

	/**
	 * Initialize tabs and download counter functionality
	 */
	function initTabs() {
		const tabs = document.querySelectorAll('.ui-tab, .nav--panels .tab')
		const panels = document.querySelectorAll('[role="tabpanel"]')

		// Initialize download counter functionality even if tabs are not present
		initDownloadCounter()

		if (tabs.length === 0) return

		// Set first tab as active by default
		if (tabs.length > 0) {
			setActiveTab(tabs[0])
		}

		/**
		 * Set the active tab and show corresponding panel
		 * @param {HTMLElement} activeTab - The tab element to activate
		 */
		function setActiveTab(activeTab) {
			// Reset all tabs to inactive state
			tabs.forEach(tab => {
				tab.classList.remove('active')
				tab.classList.remove('tab--active')
				tab.classList.add('border-transparent')
			})

			// Set active tab styling
			activeTab.classList.remove('border-transparent')
			activeTab.classList.add('active')
			activeTab.classList.add('tab--active')

			// Hide all panels
			panels.forEach(panel => {
				panel.classList.add('hidden')
				panel.classList.remove('panel--active')
				panel.setAttribute('aria-hidden', 'true')
			})

			// Show target panel
			const targetPanelId = activeTab.getAttribute('aria-controls')
			const targetPanel = document.getElementById(targetPanelId)
			if (targetPanel) {
				targetPanel.classList.remove('hidden')
				targetPanel.classList.add('block')
				targetPanel.classList.add('panel--active')
				targetPanel.setAttribute('aria-hidden', 'false')
			}
		}

		// Add click event listeners to all tabs
		tabs.forEach(tab => {
			tab.addEventListener('click', function (e) {
				e.preventDefault()
				setActiveTab(this)
			})
		})
	}

	/**
	 * Initialize download counter that updates based on checked files
	 */
	function initDownloadCounter() {
		const checkboxSelector =
			'.list--downloads input[type="checkbox"], input[type="checkbox"][name="downloads"], input[type="checkbox"][name="downloads[]"], input[type="checkbox"][name$="[downloads][]"]'
		const checkboxes = document.querySelectorAll(checkboxSelector)
		const countElements = document.querySelectorAll('[data-download-count], .downloads--number')

		/**
		 * Update the download count display
		 */
		function updateCount() {
			const checkedCount = new Set(
				Array.from(document.querySelectorAll(checkboxSelector))
					.filter(checkbox => checkbox instanceof HTMLInputElement && checkbox.checked)
					.map(checkbox => checkbox.id || checkbox.value || checkbox.name)
			).size
			countElements.forEach(countElement => {
				countElement.textContent = checkedCount
			})
		}

		// Add change event listeners to all download checkboxes
		checkboxes.forEach(checkbox => {
			checkbox.addEventListener('change', updateCount)
		})

		// Initialize count on load
		updateCount()

		// If no checkboxes found initially, try again with delay
		if (checkboxes.length === 0) {
			setTimeout(() => {
				const delayedCheckboxes = document.querySelectorAll(checkboxSelector)
				delayedCheckboxes.forEach(checkbox => {
					checkbox.addEventListener('change', updateCount)
				})
				updateCount()
			}, 500)
		}
	}
})()
